*,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  --wui-segmented-trigger-bg-hover: var(
    --wui-color-state-layer-hover,
    color-mix(in srgb, var(--wui-color-text, #1b1b1b) 6%, transparent)
  );
  --wui-segmented-trigger-bg-active: var(
    --wui-color-state-layer-active,
    color-mix(in srgb, var(--wui-color-text, #1b1b1b) 15%, transparent)
  );
  display: inline-block;
}

:host([disabled]) {
  cursor: not-allowed;
}

.wui-segmented-trigger {
  cursor: pointer;
  user-select: none;

  position: relative;
  z-index: 1;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  height: 34px;
  padding: 0 var(--wui-segmented-trigger-px, 12px);
  border-radius: calc(infinity * 1px);

  font-size: var(--wui-font-size, 14px);
  line-height: 1;
  color: var(--wui-color-text-secondary, #6a6a6a);
  white-space: nowrap;

  background-color: transparent;

  transition:
    background-color var(--wui-duration-trigger, 160ms) ease,
    color var(--wui-duration-focus, 200ms) ease;

  &:focus-visible {
    outline: var(--wui-focus-ring-width, 3px) solid var(--wui-color-focus-ring, rgb(0 136 255 / 0.4));
    outline-offset: 2px;
  }

  &.is-checked {
    color: var(--wui-color-text, #1b1b1b);
  }
}

@media (hover: hover) and (pointer: fine) {
  .wui-segmented-trigger:hover:not(.is-disabled) {
    background-color: var(--wui-segmented-trigger-bg-hover);
  }
}

.wui-segmented-trigger:active:not(.is-disabled) {
  background-color: var(--wui-segmented-trigger-bg-active);
}

.wui-segmented-trigger.is-disabled {
  cursor: not-allowed;
  opacity: 0.4;
}
